/* Fluffys morgen: scroll-scrubbed film. Vanilla JS, no dependencies. */
(function () {
  'use strict';
  var root = document.querySelector('[data-fm-film]');
  if (!root || root.dataset.fmReady) return;
  root.dataset.fmReady = '1';

  var layers = Array.prototype.slice.call(root.querySelectorAll('[data-fm-layer]'));
  var chapters = Array.prototype.slice.call(root.querySelectorAll('[data-fm-chapter]'));
  var jumpButtons = Array.prototype.slice.call(root.querySelectorAll('[data-fm-jump]'));
  var bar = root.querySelector('[data-fm-progress]');
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  var mobile = window.matchMedia('(max-width: 860px), (pointer: coarse)').matches;
  var FPS = 24;

  var state = layers.map(function (el) {
    return { el: el, video: el.querySelector('video'), src: el.dataset[mobile ? 'mobile' : 'desktop'],
      loading: false, ready: false, blobUrl: null, target: 0, current: 0, seeking: false };
  });

  var weights = [], total = 0, filmTop = 0, filmRange = 1, active = 0, inView = true, raf = 0;

  function measure() {
    weights = chapters.map(function (c) { return c.offsetHeight; });
    total = weights.reduce(function (a, b) { return a + b; }, 0) || 1;
    var rect = root.getBoundingClientRect();
    filmTop = rect.top + window.pageYOffset;
    filmRange = Math.max(1, root.offsetHeight - window.innerHeight);
  }

  function load(i) {
    var s = state[i];
    if (!s || s.loading || reduce.matches) return;
    s.loading = true;
    var v = s.video;
    var attach = function (url) {
      v.muted = true; v.defaultMuted = true;
      v.setAttribute('muted', ''); v.setAttribute('playsinline', '');
      v.preload = 'auto';
      v.src = url;
      v.addEventListener('loadeddata', function () { s.ready = true; s.current = s.target; seek(s, true); schedule(); }, { once: true });
      v.addEventListener('seeked', function () {
        s.seeking = false;
        if (s.ready) s.el.classList.add('is-painted');
        schedule();
      });
      try { v.load(); } catch (e) {}
    };
    // Blob-backed source = fully buffered, so seeking is instant (Shopify CDN sends CORS *).
    if (window.fetch && window.URL && URL.createObjectURL) {
      fetch(s.src, { mode: 'cors' }).then(function (r) {
        if (!r.ok) throw new Error(r.status);
        return r.blob();
      }).then(function (b) {
        s.blobUrl = URL.createObjectURL(b);
        attach(s.blobUrl);
      }).catch(function () { attach(s.src); });
    } else {
      attach(s.src);
    }
  }

  function seek(s, force) {
    var v = s.video;
    if (!s.ready || (s.seeking && !force)) return;
    var t = s.current;
    if (!force && Math.abs(v.currentTime - t) < 0.5 / FPS) return;
    s.seeking = true;
    try { v.currentTime = t; } catch (e) { s.seeking = false; }
  }

  function setActive(i) {
    if (i === active) return;
    layers[active].classList.remove('is-active');
    layers[i].classList.add('is-active');
    active = i;
    jumpButtons.forEach(function (b, k) {
      if (k === i) b.setAttribute('aria-current', 'step'); else b.removeAttribute('aria-current');
    });
  }

  function frame() {
    raf = 0;
    var p = Math.min(1, Math.max(0, (window.pageYOffset - filmTop) / filmRange));
    if (bar) bar.style.transform = 'scaleX(' + p.toFixed(4) + ')';
    // map global progress to (segment, local progress) using chapter heights as weights
    var acc = 0, idx = 0, local = 0, pos = p * total;
    for (var i = 0; i < weights.length; i++) {
      if (pos <= acc + weights[i] || i === weights.length - 1) {
        idx = i; local = Math.min(1, Math.max(0, (pos - acc) / weights[i])); break;
      }
      acc += weights[i];
    }
    setActive(idx);
    load(idx); load(idx + 1); if (idx > 0) load(idx - 1);
    var s = state[idx];
    var keepGoing = false;
    if (s && s.ready && !reduce.matches) {
      var dur = (s.video.duration && isFinite(s.video.duration)) ? s.video.duration : 3;
      s.target = local * Math.max(0, dur - 1 / FPS);
      var diff = s.target - s.current;
      s.current = Math.abs(diff) < 0.004 ? s.target : s.current + diff * 0.35;
      seek(s, false);
      keepGoing = Math.abs(s.target - s.current) > 0.004;
    }
    if (keepGoing && inView) schedule();
  }

  function schedule() { if (!raf) raf = window.requestAnimationFrame(frame); }

  // iOS: a muted play/pause inside the first gesture unlocks painting of seeked frames.
  function prime() {
    state.forEach(function (s) {
      if (!s.video.src) return;
      var pr = s.video.play();
      if (pr && pr.then) pr.then(function () { s.video.pause(); seek(s, true); }).catch(function () {});
    });
    window.removeEventListener('touchstart', prime);
    window.removeEventListener('pointerdown', prime);
  }

  jumpButtons.forEach(function (b, k) {
    b.addEventListener('click', function () {
      measure();
      var before = 0;
      for (var i = 0; i < k; i++) before += weights[i];
      var y = filmTop + (before / total) * filmRange + 2;
      window.scrollTo({ top: y, behavior: reduce.matches ? 'auto' : 'smooth' });
    });
  });

  measure();
  if ('IntersectionObserver' in window) {
    new IntersectionObserver(function (e) { inView = e[0].isIntersecting; if (inView) schedule(); }).observe(root);
  }
  window.addEventListener('scroll', schedule, { passive: true });
  window.addEventListener('resize', function () { measure(); schedule(); });
  window.addEventListener('load', function () { measure(); schedule(); });
  window.addEventListener('touchstart', prime, { passive: true });
  window.addEventListener('pointerdown', prime, { passive: true });
  if (reduce.addEventListener) reduce.addEventListener('change', schedule);
  // Start loading the first clip after the poster has painted.
  if (!reduce.matches) {
    var kick = function () { load(0); load(1); };
    if ('requestIdleCallback' in window) requestIdleCallback(kick, { timeout: 1500 }); else setTimeout(kick, 600);
  }
  schedule();
})();
